export default __webpack_public_path__ + "static/ab-sketches-mobile-9fb22a3b8affd4f4e3ef09ca5eafa008.jpg";